import { useEffect } from 'react';
import { useStores } from 'stores/index';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { getLayoutRoutes } from 'src/routes';
import { publish } from 'libs/pubsub';

//@ts-ignore
import { Card, Form, FormItem, InputText, useForm, Button, notify } from '@microui/react-ui';

const Main = () => {
    const { userStore, rootStore } = useStores();
    const [form] = useForm();
    const navigate = useNavigate();

    useEffect(() => {
        if (form) {
            form.setFieldsValue({
                code: ''
            });
        }
    }, []);

    const handleSubmit = (data) => {
        userStore.verify(data)
            .then(() => {
                form.resetFields();
                notify.success('Xác minh thành công thành công');
                navigate('/user/profile');
            });
    };

    return (
        <div className="p-6 flex flex-col items-center">
            <Card
                head={
                    <div className='w-full text-center text-headline-4 text-primary-400 font-medium'>
                        Xác thực tài khoản
                    </div>
                }
                className={'max-w-[800px]'}
            >
                <div className="p-6">
                    <Form
                        form={form}
                        onFinish={handleSubmit}
                    >
                        <p className='text-left text-gray mb-6'>
                            Vui lòng nhập mã xác minh tài khoản để sử dụng hết các tính năng của chúng tôi. Mã xác minh đã được gửi vào mail của bạn khi đang ký.
                        </p>

                        <FormItem
                            label='Mã xác nhận'
                            name="code"
                            required
                        >
                            <InputText disabled={userStore.loading} placeholder="Nhập mã xác nhận" />
                        </FormItem>
                    </Form>

                    <div className="flex w-full items-center justify-center pt-5">
                        <Button loading={userStore.loading} onClick={form.submit} type='primary' color='primary'>Xác minh</Button>
                    </div>
                </div>
            </Card>
        </div>
    );
}

export default observer(Main);